(() => {
  const ROOT_SELECTORS = [
    ':is(#rhd-specificity, [id$="__main"])',
    '[id^="ProductInformation-"]:is(#rhd-specificity, [id$="__main"])',
    '[data-testid="product-list"]'
  ];
  const PRICE_SELECTORS = ['product-price .price', 'product-price .compare-at-price'];
  const BOOT_DELAYS = [50, 150, 400, 900, 1500];
  const observers = [];
  let scheduled = false;

  const formatPriceText = (text) => {
    if (!text) return text;
    return text
      .replace(/\u00A0/g, ' ')
      .replace(/(€\s*\d{1,3}(?:\.\d{3})*),00\b/g, '$1')
      .replace(/(€\s*\d+),00\b/g, '$1')
      .replace(/(\d{1,3}(?:\.\d{3})*),00\s*€/g, '$1 €')
      .replace(/(\d+),00\s*€/g, '$1 €')
      .trim();
  };

  const cleanElement = (el) => {
    if (!el) return;

    const current = el.textContent || '';
    const cleaned = formatPriceText(current);

    if (cleaned !== current) {
      el.textContent = cleaned;
    }
  };

  const getRoots = () => {
    const uniqueRoots = [];

    ROOT_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((root) => {
        if (
          uniqueRoots.includes(root)
          || !root.querySelector('product-price .price, product-price .compare-at-price')
        ) {
          return;
        }

        uniqueRoots.push(root);
      });
    });

    return uniqueRoots;
  };

  const run = () => {
    getRoots().forEach((root) => {
      PRICE_SELECTORS.forEach((selector) => {
        root.querySelectorAll(selector).forEach(cleanElement);
      });
    });
  };

  const scheduleRun = () => {
    if (scheduled) return;

    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  };

  const disconnectObservers = () => {
    observers.splice(0).forEach((observer) => observer.disconnect());
  };

  const boot = () => {
    const roots = getRoots();

    if (!roots.length) {
      disconnectObservers();
      return;
    }

    disconnectObservers();
    run();
    requestAnimationFrame(run);

    BOOT_DELAYS.forEach((delay) => {
      setTimeout(run, delay);
    });

    roots.forEach((root) => {
      const observer = new MutationObserver(scheduleRun);

      observer.observe(root, {
        subtree: true,
        childList: true,
        characterData: true
      });

      observers.push(observer);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('load', boot, { once: true });
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('variant:change', boot);
  document.addEventListener('change', (event) => {
    if (event.target && event.target.closest('product-form-component, variant-selects, variant-radios')) {
      boot();
    }
  });

  window.stripShopifyZeroDecimals = boot;
})();
